import { useState, useEffect } from "react";
import { fetchSheetData } from "./fetchSheetData";

export const useMixData = (sheetId) => {
  const [mixData, setMixData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await fetchSheetData(sheetId, "Mixes!A1:D50");
        setMixData(data);
      } catch (e) {
        console.error("Error fetching mixed:", e.message);
      }
    };
    fetchData();
  }, [sheetId]); // Re-fetch when sheetId changes

  const sortedData = mixData ? [...mixData].sort((a, b) => b.id - a.id) : [];

  return sortedData;
};
